<div class="d-flex">
  <div class="form-row" (keydown.enter)="update()">
    <div class="form-group col">
      <app-tracking-tracker-filter [placeholder]="'Search Master BL/AWB#'"
        (inputChange)="onFilterInputChange($event, columns.MasterBillNumber)">
      </app-tracking-tracker-filter>
    </div>
    <div class="form-group col">
      <app-tracking-tracker-filter [placeholder]="'Search House B/L#'"
        (inputChange)="onFilterInputChange($event, columns.HouseBillNumber)">
      </app-tracking-tracker-filter>
    </div>
    <div class="form-group col">
      <app-tracking-tracker-filter [placeholder]="'Search Container#'"
        (inputChange)="onFilterInputChange($event, columns.ContainerNumber)">
      </app-tracking-tracker-filter>
    </div>
    <div class="form-group col">
      <app-tracking-tracker-filter [placeholder]="'Search Order/Ref/INV#'"
        (inputChange)="onFilterInputChange($event, columns.CustomerRefNumber)">
      </app-tracking-tracker-filter>
    </div>
    <div class="form-group col">
      <app-tracking-tracker-filter [placeholder]="'Search Shipment Number#'"
        (inputChange)="onFilterInputChange($event, columns.ShipmentCode)">
      </app-tracking-tracker-filter>
    </div>

    <button type="submit" class="search"
      [disabled]="!isFilterChanged() || isFilterEmpty()"
      (click)="update()">
      <i class="material-icons" title="Search">search</i>
    </button>

    <button type="button"
            class="search clear-btn"
            [disabled]="isFilterEmpty()"
            (click)="clearFilters()">
      <i class="material-icons" title="Clear Filters">clear</i>
    </button>
  </div>
</div>